import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import MicIcon from '@mui/icons-material/Mic';
import { IconButton, InputBase, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const Root = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, rgb(223, 223, 253) 0%, rgb(255, 255, 255) 100%);
`;

const Content = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 680px;
  max-width: 100%;
  padding: 0 24px;
`;

const AiLogoRing = styled('div')`
  width: 130px;
  height: 130px;
  border-radius: 50%;
  border: 3px solid transparent;
  background:
    linear-gradient(white, white) padding-box,
    linear-gradient(135deg, #ac8eff 0%, #51b7d8 100%) border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const SuggestionsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const SuggestionChip = styled('div')`
  border: 1px solid #d5d7eb;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;

  &:hover {
    background: rgba(106, 69, 211, 0.04);
  }
`;

const SearchWrapper = styled('div')`
  border: 1px solid #282e9a;
  border-radius: 4px;
  height: 44px;
  display: flex;
  align-items: center;
  padding: 4px 4px 4px 12px;
  width: 100%;
  gap: 8px;
`;

const MicButton = styled(IconButton)`
  background: #6a45d3;
  border-radius: 24px;
  width: 36px;
  height: 36px;
  flex-shrink: 0;

  &:hover {
    background: #5a35c3;
  }
`;

const LearnSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const CardsRow = styled('div')`
  display: flex;
  gap: 4px;
  width: 100%;
`;

const InfoCard = styled('div')`
  border: 2px solid white;
  border-radius: 4px;
  padding: 8px 16px;
  flex: 1;
  background: rgba(249, 250, 250, 0.8);
  box-shadow:
    0px 4px 24px 0px rgba(16, 37, 62, 0.04),
    0px 24px 48px 0px rgba(75, 82, 93, 0.02);
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const CardHeader = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SavedSearchIcon = styled('div')`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const SavedSearchIconInner = styled('span')`
  font-size: 18px;
  background: linear-gradient(135deg, #6a45d3 0%, #51b7d8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
`;

export function SourcingListsView() {
  return (
    <Root>
      <Content>
        <AiLogoRing>
          <AutoAwesomeIcon sx={{ fontSize: 64, color: '#6a45d3' }} />
        </AiLogoRing>

        <Typography variant='h6' color='text.primary' align='center' sx={{ letterSpacing: 0.15 }}>
          What companies do you want to discover today?
        </Typography>

        <SuggestionsWrapper>
          <SuggestionChip>
            <Typography variant='body2' color='text.primary'>
              Companies with positive EBITDA for the last 3 quarters and a valuation under $50M
            </Typography>
          </SuggestionChip>
          <SuggestionChip>
            <Typography variant='body2' color='text.primary'>
              SaaS companies in Europe with ARR over $10M and growing 50%+ YoY
            </Typography>
          </SuggestionChip>

          <SearchWrapper>
            <InputBase
              fullWidth
              placeholder='Search for companies using natural language…'
              sx={{ fontSize: 16, color: '#b6bbc4' }}
            />
            <MicButton size='small'>
              <MicIcon sx={{ fontSize: 20, color: 'white' }} />
            </MicButton>
          </SearchWrapper>
        </SuggestionsWrapper>

        <LearnSection>
          <Typography variant='body2' color='text.primary' sx={{ letterSpacing: 0.17 }}>
            Learn how lists work
          </Typography>
          <CardsRow>
            <InfoCard>
              <CardHeader>
                <ArticleOutlinedIcon sx={{ fontSize: 24, color: 'text.secondary' }} />
                <Typography variant='body2' color='text.primary' sx={{ fontWeight: 500 }}>
                  List
                </Typography>
              </CardHeader>
              <Typography variant='caption' color='text.secondary'>
                Manually managed list.
                <br />
                Add or remove companies anytime.
              </Typography>
            </InfoCard>
            <InfoCard>
              <CardHeader>
                <SavedSearchIcon>
                  <SavedSearchIconInner>
                    <AutoAwesomeIcon sx={{ fontSize: 20 }} />
                  </SavedSearchIconInner>
                </SavedSearchIcon>
                <Typography variant='body2' color='text.primary' sx={{ fontWeight: 500 }}>
                  Saved Search
                </Typography>
              </CardHeader>
              <Typography variant='caption' color='text.secondary'>
                Generated from a saved search query.
                <br />
                Results can refresh automatically.
              </Typography>
            </InfoCard>
          </CardsRow>
        </LearnSection>
      </Content>
    </Root>
  );
}
